import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar
} from 'reactstrap';  
import Select from 'react-select';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { addMeioAmbienteTipologia, updateMeioAmbienteTipologia } from "../../Services/MeioAmbienteTipologiaService";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      grupos: [],
      selectedGrupo: '',
      selectOptionsG: [],
      areas: [],
      selectedAreas: '',
      selectOptionsA: [],
      data: {
        id: '',
				name: '',
        code: '',
        unidadeMedida: '',
        portePequeno: '',
        porteMedio: '',
        porteGrande: '',
        potencialPoluidor: '',
        competenciaNivel1: '',
        competenciaNivel2: '',
        competenciaNivel3: '',
        meioAmbienteGrupo: {},
        meioAmbienteAreas: {},
				status: "ATIVO",
				deleted: false,
				createdAt: '',
				updatedAt: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(this.validateEntries()){

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }

      if(data.meioAmbienteAreas === undefined || data.meioAmbienteAreas === null || 
        data.meioAmbienteAreas.id === undefined || data.meioAmbienteAreas.id === null || data.meioAmbienteAreas.id === 0){
        data['meioAmbienteAreas'] = null;
      }
      
      if(data.id === undefined || data.id === null || data.id === ''){
        addMeioAmbienteTipologia(data)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable({}, this.props.t('forms.dataCreateSuccess'));
              this.clear({});              
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }
            }
          } else {
            this.show('danger', this.props.t('forms.dataCreateError'));
          }
        });

      }else{
        updateMeioAmbienteTipologia(data)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;

    if(data.name === undefined || data.name === null || data.name === ''){
      this.show('danger', this.props.t('forms.requiredFieldName'));
      validated = false;
    }
    
    if(data.code === undefined || data.code === null || data.code === ''){
      this.show('danger', this.props.t('forms.requiredFieldCode'));
      validated = false;
    }
    
    if(data.code === undefined || data.code === null || data.code === ''){
      this.show('danger', this.props.t('forms.requiredFieldUnidadeMedida'));
      validated = false;
    }
    
    if(data.code === undefined || data.code === null || data.code === ''){
      this.show('danger', this.props.t('forms.requiredFieldPotencialPoluidor'));
      validated = false;
    }
    
    if(data.code === undefined || data.code === null || data.code === ''){
      this.show('danger', this.props.t('forms.requiredFieldPortePequeno'));
      validated = false;
    }
    
    if(data.code === undefined || data.code === null || data.code === ''){
      this.show('danger', this.props.t('forms.requiredFieldPorteMedio'));
      validated = false;
    }
    
    if(data.code === undefined || data.code === null || data.code === ''){
      this.show('danger', this.props.t('forms.requiredFieldPorteGrande'));
      validated = false;
    }
    
    if(data.code === undefined || data.code === null || data.code === ''){
      this.show('danger', this.props.t('forms.requiredFieldCompetenciaNivel2'));
      validated = false;
    }
    
    if(data.code === undefined || data.code === null || data.code === ''){
      this.show('danger', this.props.t('forms.requiredFieldCompetenciaNivel3'));
      validated = false;
    }

    return validated;
  }

  loadData(selected, grupos) {
    let options = [];
    
    if(grupos !== undefined && grupos !== null && grupos.length > 0 && this.state.grupos.length === 0){
      for(let i = 0; i < grupos.length; i++){
        options.push({value:grupos[i].id, label: grupos[i].code + " - " + grupos[i].name});
      }
      this.setState({ 
        selectOptionsG: options, 
        grupos: grupos 
      });
    }

    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear();
      }else {

        let selectedGrupo = '';
        let selectedAreas = '';
        let areas = [];
        let selectOptionsA = [];
        if(selected.meioAmbienteGrupo !== undefined && selected.meioAmbienteGrupo !== null && selected.meioAmbienteGrupo.id !== null){
          selectedGrupo = {value:selected.meioAmbienteGrupo.id, label: selected.meioAmbienteGrupo.code + " - " + selected.meioAmbienteGrupo.name};
          options = [];
          for(let i = 0; i < grupos.length; i++){
            if(selectedGrupo.value === grupos[i].id){
              if(grupos[i].areas !== undefined && grupos[i].areas !== null && grupos[i].areas.length > 0){
                areas = grupos[i].areas;
                for(let j = 0; j < grupos[i].areas.length; j++){
                  options.push({value:grupos[i].areas[j].id, label: grupos[i].areas[j].code + " - " + grupos[i].areas[j].name});
                }
              }
              selectOptionsA = options;

              if(selected.meioAmbienteAreas !== undefined && selected.meioAmbienteAreas !== null && selected.meioAmbienteAreas.id !== null){
                selectedAreas = {value:selected.meioAmbienteAreas.id, label: selected.meioAmbienteAreas.code + " - " + selected.meioAmbienteAreas.name};
              }
              break;
            }
          }
        }

        this.setState({ 
          data: selected, selectedGrupo, areas, selectOptionsA, selectedAreas
        }, () => {});
      }
    }
  }

  componentDidMount() {
    const { selected, grupos, areas } = this.props;
    this.loadData(selected, grupos, areas);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected || props.grupos !== this.props.grupos || 
        props.areas !== this.props.areas){
      this.loadData(this.props.selected, this.props.grupos, this.props.areas);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value
    this.setState({ data });
  }

  updateGrupoSelect(event) {
    const data = { ...this.state.data }

    let selectedGrupo = '';
    let selectOptionsA = [];
    data["meioAmbienteGrupo"] = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        for(let i = 0; i < this.state.selectOptionsG.length; i++){
          if(this.state.selectOptionsG[i].value === event[j].value){
            selectedGrupo = event[j];
            
            for(let e = 0; e < this.state.grupos.length; e++){
              if(this.state.grupos[e].id === selectedGrupo.value){
                data["meioAmbienteGrupo"] = this.state.grupos[e];

                let options = [];
                let areas = this.state.grupos[e].areas;
                for(let j = 0; j < areas.length; j++){
                  options.push({value:areas[j].id, label: areas[j].code + " - " + areas[j].name});
                }
                selectOptionsA = options;
                break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({ data, selectedGrupo, selectOptionsA });
  }

  updateAreasSelect(event) {
    const data = { ...this.state.data }

    let selectedAreas = '';
    data["meioAmbienteAreas"] = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        for(let i = 0; i < this.state.selectOptionsA.length; i++){
          if(this.state.selectOptionsA[i].value === event[j].value){
            selectedAreas = event[j];
            
            for(let e = 0; e < this.state.areas.length; e++){
              if(this.state.areas[e].id === selectedAreas.value){
                data["meioAmbienteAreas"] = this.state.areas[e];
                break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({ data, selectedAreas });
  }

  clear(){
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['code'] = '';
    data['unidadeMedida'] = '';
    data['portePequeno'] = '';
    data['porteMedio'] = '';
    data['porteGrande'] = '';
    data['potencialPoluidor'] = '';
    data['competenciaNivel1'] = '';
    data['competenciaNivel2'] = '';
    data['competenciaNivel3'] = '';
    data['meioAmbienteGrupo'] = {};
    data['meioAmbienteAreas'] = {};
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';
    this.setState({ 
      data,
      selectedGrupo: [],
      selectedAreas: []
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    
    let notOK = !hasAccess("MENU_MEIO_AMBIENTE_TIPOLOGIA_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.createUpdate')}</h3>
            </div>
            <div className="form">

              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.name')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="hidden" 
                      name="id"
                      value={this.state.data.id} />
                    <input type="text" 
                      name="name"
                      value={this.state.data.name}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.unidadeMedida')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="unidadeMedida"
                      value={this.state.data.unidadeMedida}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.portePequeno')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="portePequeno"
                      value={this.state.data.portePequeno}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.porteMedio')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="porteMedio"
                      value={this.state.data.porteMedio}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.porteGrande')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="porteGrande"
                      value={this.state.data.porteGrande}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.code')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="code"
                      value={this.state.data.code}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.potencialPoluidor')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="potencialPoluidor"
                      value={this.state.data.potencialPoluidor}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.competenciaNivel1')} 
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="competenciaNivel1"
                      value={this.state.data.competenciaNivel1}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.competenciaNivel2')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="competenciaNivel2"
                      value={this.state.data.competenciaNivel2}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.competenciaNivel3')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="competenciaNivel3"
                      value={this.state.data.competenciaNivel3}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.meioAmbienteGrupo_form.title')} <span style={{color: "#ff0000"}}>*</span>
                </span>
                <div className="form__form-group-field">
                  <Select
                    isMulti = "true"
                    maxMenuHeight="150px"
                    name="meioAmbienteGrupo"
                    value={this.state.selectedGrupo}
                    onChange={e => this.updateGrupoSelect(e)}
                    options={this.state.selectOptionsG}
                    clearable={true}
                    className="react-select"
                    classNamePrefix="react-select"
                    required
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.meioAmbienteAreas_form.title')} 
                </span>
                <div className="form__form-group-field">
                  <Select
                    isMulti = "true"
                    maxMenuHeight="150px"
                    name="meioAmbienteAreas"
                    value={this.state.selectedAreas}
                    onChange={e => this.updateAreasSelect(e)}
                    options={this.state.selectOptionsA}
                    clearable={true}
                    className="react-select"
                    classNamePrefix="react-select"
                    required
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.status')}
                </span>
                <div className="form__form-group-field">
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.ativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'ATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.ativo')}</span>
                  </label>
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.inativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'INATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.inativo')}</span>
                  </label>
                </div>
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'meioAmbienteTipologiaEdit', 
})(withTranslation('common')(CrudEdit));
